const WHATSAPP_URL = 'https://wa.me/5519988179126';
const INSTAGRAM_URL = 'https://www.instagram.com/turminhadalegriaa/';

const links = [
  { label: 'A Escola', href: '#sobre' },
  { label: 'Turmas', href: '#turmas' },
  { label: 'Metodologia', href: '#metodologia' },
  { label: 'Galeria', href: '#galeria' },
  { label: 'Contato', href: '#contato' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-azul-escuro text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/dbb91ed3e4be9c76a73c295c28ca35e3.png"
              alt="Escola Infantil Turminha da Alegria"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="font-body text-white/70 text-sm leading-relaxed mb-2">
              Escola Infantil Turminha da Alegria
            </p>
            <p className="font-body text-white/50 text-xs">CNPJ: 28.790.383/0001-68</p>
            <div className="flex gap-3 mt-5">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-vermelho rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-base" />
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-vermelho rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-base" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h6 className="font-heading text-white text-lg mb-5">Links Rápidos</h6>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleNav(link.href)}
                    className="font-body text-white/70 text-sm hover:text-white hover:pl-1 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line mr-1" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h6 className="font-heading text-white text-lg mb-5">Informações</h6>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-azul-claro text-base mt-0.5 flex-shrink-0" />
                <p className="font-body text-white/70 text-sm">
                  Rua Maria Aparecida Roqui, 177<br />
                  Parque Santa Bárbara – Campinas/SP<br />
                  CEP 13064-470
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-azul-claro text-base flex-shrink-0" />
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-white/70 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  +55 (19) 98817-9126
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-azul-claro text-base flex-shrink-0" />
                <p className="font-body text-white/70 text-sm">
                  Seg – Sex: 07h00 às 18h00
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-white/50 text-xs text-center">
            © 2026 Escola Infantil Turminha da Alegria. Todos os direitos reservados.
          </p>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
